// extracted by css-extract-rspack-plugin
export default {"image":"image-Wa19aO","pdf":"pdf-IoDYm2"};